import { useEffect, useState } from 'react'
import Axios from 'axios'
import Chart from 'react-apexcharts'

const params = {
  "Opcion": "1",
  "FIni": "20220801",
  "FFin": ""
}

const chartOptions = {
  chart: {
    height: 350,
    type: 'line',
    zoom: {
      enabled: false
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    width: Array(7).fill(5),
    curve: 'straight',
    dashArray: [0, 0, 0, 0, 4, 6, 8]
  },
  legend: {
    labels: {
      colors: '#fff',
    },
    markers: {
      radius: 3,
    },
  },
  markers: {
    size: 0,
    hover: {
      sizeOffset: 6
    }
  },
  yaxis: {
    max: (max) => {
      return Math.ceil(max / 100000) * 100000
    },
    tickAmount: 5,
    labels: {
      style: {
        colors: ['#9197a1']
      },
      formatter: (value) => {
        return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
      },
    }
  },
  xaxis: {
    categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre',
      'Octubre', 'Noviembre', 'Diciembre'
    ],
    labels: {
      style: {
        colors: Array(12).fill('#9197a1')
      }
    }
  },
  theme: {
    mode: 'light',
    palette: 'palette4',
  },
  tooltip: {
    y: [
      {
        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
          return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
        },
      },
      {
        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
          return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
        },
      },
      {
        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
          return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
        },
      },
      {
        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
          return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
        },
      },
      {
        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
          return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
        },
      },
      {
        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
          return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
        },
      },
      {
        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
          return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
        },
      },
    ]
  },
  grid: {
    show: false,
  }
}

const IngresosPorSede = ({ url, headers, FFin, setLoadingAPIS }) => {

  params.FFin = FFin

  const [data, setData] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios({
          method: 'GET',
          url: url,
          headers: headers,
          params: params,
        })
        setData(response.data)
        setLoadingAPIS(curr => ({...curr, IngresosPorSede: true}))
      } catch (err) {
        console.log(err)
      }
    }
    fetchData()
  }, [])

  const series = dataFormatter(data)

  return (
    <>
      <div className='bg-primarioMira rounded-lg p-5'>
        <h2 className="text-lg font-medium leading-6 text-white">Ingreso por sede</h2>
      </div>
      <div className='px-5 pb-5'>
        <Chart
          options={chartOptions}
          series={series}
          type='line'
          height='330px'
        />
      </div>      
    </>
  )
}

const dataFormatter = (data) => {
  let arr = []
  data.map((obj) => {
    arr.push({
      name: Object.values(obj)[13],
      data: Object.values(obj).slice(0, 12)
    })
    return arr
  })
  return arr
}

export default IngresosPorSede
